import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as me from '../../me'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * TODO:
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'SummitAllocations',
      selectors: () => new Selectors(this),
    })

    const meFeature = ngCore.inject(me.Feature)

    this.registerEffects(
      effects.onAssignmentsRequest(meFeature),
      effects.onUnitsRequest(meFeature),
      effects.onOutcomesRequest(meFeature),
      effects.triggerLoadingOnContextChange(meFeature),
      effects.triggerAssignmentsLoadingOnFilterChange(),
    )
  }
}
